import { useEffect, useState } from 'react'

export function useBreakpoint() {
  const [isMobile, setIsMobile] = useState(false)
  const [isDesktop, setIsDesktop] = useState(true)

  useEffect(() => {
    if (typeof window === 'undefined') return

    const check = () => {
      const mobile = window.innerWidth <= 480

      setIsMobile(mobile)
      setIsDesktop(!mobile)
    }

    check()

    window.addEventListener('resize', check)

    return () => window.removeEventListener('resize', check)
  }, [])

  return { isMobile, isDesktop }
}
